<template>
  <el-dialog
    v-drag
    title="保存为模板"
    :visible.sync="dialogVisible"
    width="608px"
    :before-close="cancel"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <el-form
      ref="idfTplInfo"
      class="form"
      :model="form"
      :rules="rules"
      label-position="top"
      @submit.native.prevent
    >
      <el-form-item prop="name" label="ISF模板名称">
        <el-input v-model="form.name" placeholder="请输入模板名称" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="footers">
      <div class="cancel" @click="cancel">取消</div>
      <div class="ok" @click="ok('idfTplInfo')">确定</div>
    </span>
  </el-dialog>
</template>
<script>
import { saveISFTemplate } from '@/api/bill'
export default {
  props: {
    dialogVisible: {
      tyep: Boolean,
      default: false
    },
    isfTpl: {
        type: Object,
        default: function() {
            return {}
        }
    }
  },
  data() {
    return {
      form: {
        name: ''
      },
      rules: {
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
            if (valid) {
                const param = {
                    ...this.form,
                    value: JSON.stringify(this.isfTpl)
                }
                const res = await saveISFTemplate(param)
                if (res.success) {
                    this.$message.success('保存模板成功')
                    this.$emit('ok')
                } else {
                    this.$message.error(res.errorMessage)
                }
            }
        })
    },
    cancel() {
        this.$emit('cancel')
    }
  }
}
</script>
<style lang="less" scoped>
.form {
    width: 400px;
    margin: 0 auto;
    height: auto;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #f2f7ff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dbe4f2;
    color: #7c8db5;
    margin-right: 16px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    text-align: center;
    cursor: pointer;
    line-height: 40px;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    color: #ffffff;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    padding: 0;
    text-align: center;
    cursor: pointer;
    line-height: 40px;
  }
}
</style>
